import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { dashboardClientAPIAtom } from './atoms';
import { dashboardFilterChangeTrackerAtom } from './filterAtom';

export const useDeselectOnFilterChange = () => {
  const gridApi = useAtomValue(dashboardClientAPIAtom);
  const filterChangeTracker = useAtomValue(dashboardFilterChangeTrackerAtom);

  useEffect(() => {
    if (gridApi) {
      gridApi.deselectAll();
    }
  }, [filterChangeTracker, gridApi]);
};
